import styled from 'styled-components';
import { Box } from "../../../box/src";
export const FadeOutLoadingBox = styled(Box) `
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
  pointer-events: ${({ $isLoading }) => ($isLoading ? 'none' : 'auto')};
`;
//# sourceMappingURL=FadeOutLoadingBox.js.map